import { useEffect, useState } from "react";
import Close from "../../../assets/svg/Close";
import { merchantInfo } from "../../../api/client/listing";
import Loader from "../../common/Loader";
export const ProfileDetails = ({ merchantCode, handleOnClose }) => {
  const [merchantAccount, setMerchantAccount] = useState({});
  const [merchantApplication, setMerchantApplication] = useState([]);
  const [accountApplication, setAccountApplication] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    initialProfile();
  }, []);

  const initialProfile = async () => {
    const _requestData = {
      merchant_code: merchantCode,
    };
    try {
      const response = await merchantInfo(_requestData);
      if (response.error === 0) {
        setIsLoading(false);
        setMerchantAccount(response?.data?.merchant);
        setMerchantApplication(response?.data?.merchant_application);
        setAccountApplication(response?.data?.account_application);
      } else {
        handleOnClose();
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      handleOnClose();
    }
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 text-gray-500">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={() => handleOnClose()}
      ></div>
      <div
        className="bg-white p-6 mx-4 rounded-3xl relative w-500"
        style={{ height: "450px" }}
      >
        <button
          className="absolute top-6 left-6 text-gray-400 hover:text-gray-600"
          onClick={handleOnClose}
        >
          <Close className="w-4 h-4" />
        </button>
        {isLoading && (
          <div className="mt-5">
            <Loader size="w-8 h-8" borderColor="border-primary-500" />
          </div>
        )}

        {!isLoading && (
          <div className="mt-10">
            <div className="text-sm mt-5">
              <div className="flex flex-col">
                <div className="align-center self-center justify-self-center">
                  {merchantAccount?.profile_img !== "" ? (
                    <img
                      draggable="false"
                      className="mr-3 text-center text-white rounded-full bg-primary-500 w-36 h-36 bg-no-repeat bg-cover"
                      src={merchantAccount?.profile_img}
                      alt={merchantAccount?.full_name}
                    />
                  ) : (
                    <div className="mr-3 rounded-full defaulticon w-36 h-36 bg-no-repeat bg-cover"></div>
                  )}
                </div>

                <div className="my-4 text-center">
                  <p className="text-lg">{merchantAccount?.full_name}</p>
                  <p className="text-base text-primary-500">
                    {merchantAccount?.merchant_name}
                  </p>
                </div>
                <div className="mt-2 flex flex-row gap-x-4">
                  <p className="self-center">{merchantAccount?.address}</p>
                </div>

                {accountApplication?.length > 0 && (
                  <div className="text-primary-500 mb-2">
                    Identity Confirmed
                  </div>
                )}
                {accountApplication?.length > 0 && (
                  <div className="flex flex-row gap-x-4">
                    <div className="w-6 h-6">
                      <div className="check w-full h-full bg-no-repeat bg-contain"></div>
                    </div>
                    <p className="self-center">Government ID</p>
                  </div>
                )}

                {merchantApplication?.length > 0 && (
                  <div className="flex flex-row gap-x-4">
                    <div className="w-6 h-6">
                      <div className="check w-full h-full bg-no-repeat bg-contain"></div>
                    </div>
                    <p className="self-center">Business Permit and/or Any Valid Identification</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
